import request from '@/config/axios'

/** 平台配置 VO */
export interface PlatformConfigVo {
  /** 平台抽成比例（%，结算入账=订单金额×(1-比例/100)） */
  commissionRatePercent: number
}

export const PlatformConfigApi = {
  // 获取平台配置（当前含抽成比例）
  getConfig: () => {
    return request.get({ url: '/xuanxue/platform-config/get' })
  },
  // 保存平台配置（抽成比例 0-50；修改后对新完成订单结算生效）
  updateConfig: (data: PlatformConfigVo) => {
    return request.put({ url: '/xuanxue/platform-config/update', data })
  }
}
